import { createSlice } from '@reduxjs/toolkit';

const initialState = { data: null, status: 'idle', error: null };

const getUserDataSlice = createSlice({
  name: 'userData',
  initialState,
  reducers: {
    userDataRequest(state) {
      state.status = 'loading';
      state.error = null;
    },
    userDataSuccess(state, action) {
      state.status = 'succeeded';
      state.data = action.payload;
    },
    userDataFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
    userDataReset(state) {
      state.status = 'idle';
      state.error = null;
      state.data = null;
    },
  },
});

export const getUserDataAction = getUserDataSlice.actions;
export default getUserDataSlice;
